// extracted by mini-css-extract-plugin
module.exports = {"ContentFullScreen2":"ContentCenter_ContentFullScreen2__9_E43","bgImage":"ContentCenter_bgImage__9Imdn"};